// ── CATÁLOGO DE PRODUCTOS ──
// Para vender un producto nuevo, agrégalo aquí con su variant ID de Shopify
// (Admin → Productos → el producto → variante, o abre /products/<handle>.js → variants[0].id).
// Si un producto tiene variantes (p. ej. tallas de gorra), cada variante es una entrada.
const CATALOG = {
  'soft-ice':    { variant: '51631606038845', price: 549, name: 'Soft Ice (docena)' },
  'ball-marker': { variant: '53080642322749', price: 199, name: 'Ball marker SubZero' }  // borrador en Shopify: publicar + inventario
};
// ── PACK (pop up al entrar) ──
// ⚠ El tema solo lo ANUNCIA y lo agrega al carrito. El precio especial lo aplica un
// descuento automático en Shopify (Compra X, lleva Y: 2 Soft Ice → $97 menos en el
// Ball Marker, 1 uso por pedido). Si cambias el precio aquí, cámbialo también allá.
const PACK = {
  name: 'COLD PACK',             // = título del descuento automático en Shopify
  items: [['soft-ice', 2], ['ball-marker', 1]],
  price: 1200,
  // false = el pop up NO sale solo (en diseño). Para revisarlo: ?pack=1 en la URL
  active: false
};
function packRegular(){ return PACK.items.reduce(function(t, it){ return t + CATALOG[it[0]].price * it[1]; }, 0); }
const BALLS_PER_DOZEN = 12;
const FREE_SHIP = 999;      // envío gratis desde este subtotal, sin importar el producto
const MIN_QTY = 1;
const MAX_QTY = 12;

// Producto que se compra con el selector de cantidad. En el home es Soft Ice;
// en una página de producto lo define la plantilla (data-main-*), así cada
// producto vende lo suyo y no Soft Ice.
var mainItem = { handle: 'soft-ice', variant: CATALOG['soft-ice'].variant, price: CATALOG['soft-ice'].price };
(function(){
  var el = document.querySelector('[data-main-variant]');
  if(!el) return;
  mainItem = {
    handle:  el.getAttribute('data-main-handle') || '',
    variant: el.getAttribute('data-main-variant'),
    price:   parseFloat(el.getAttribute('data-main-price')) || 0
  };
})();

let qty = 1;               // cuántas unidades del producto principal se van a agregar
function fmt(n){return '$'+n.toLocaleString('es-MX');}

// Lo que sumaría el selector de cantidad si lo agregas ahora
function pendiente(){ return qty * mainItem.price; }

function render(){
  var balls = qty * BALLS_PER_DOZEN;
  var total = pendiente();
  // La barra proyecta: lo que ya llevas en el carrito + lo que estás por agregar.
  // El mensaje distingue "ya lo tienes" de "con esto llegas".
  var proyectado = CART.subtotal + total;
  var noun = qty===1?'docena':'docenas';
  document.querySelectorAll('[data-qty]').forEach(function(e){e.textContent = qty;});
  document.querySelectorAll('[data-qty-noun]').forEach(function(e){e.textContent = noun;});
  document.querySelectorAll('[data-qty-balls]').forEach(function(e){e.textContent = balls;});
  document.querySelectorAll('[data-qty-total]').forEach(function(e){e.textContent = fmt(total);});
  document.querySelectorAll('[data-price]').forEach(function(e){e.textContent = fmt(total);});
  var pct = Math.min(100, Math.round(proyectado/FREE_SHIP*100));
  document.querySelectorAll('[data-ship-fill]').forEach(function(e){e.style.width = pct+'%';});
  var msg = proyectado >= FREE_SHIP
    ? '¡Felicidades! Tienes envío gratis ❄'
    : 'Te faltan ' + fmt(FREE_SHIP - proyectado) + ' para envío gratis';
  document.querySelectorAll('[data-ship-msg]').forEach(function(e){e.textContent = msg;});
  document.querySelectorAll('.qbtn-mini-minus, .qbtn.minus').forEach(function(b){b.disabled = qty<=MIN_QTY;});
  document.querySelectorAll('.qbtn-mini-plus, .qbtn.plus').forEach(function(b){b.disabled = qty>=MAX_QTY;});
}
function step(d){ qty = Math.max(MIN_QTY, Math.min(MAX_QTY, qty+d)); render(); }
// ── NAVEGACIÓN A SECCIONES ──
// Centra la sección en el espacio libre bajo la barra fija; si no cabe,
// la pega justo debajo. Evita que la barra se coma el inicio de la sección.
function navHeight(){ var n = document.querySelector('nav'); return n ? n.getBoundingClientRect().height : 70; }

// En móvil la sección de producto apila primero el texto, así que apuntamos
// directo a la tarjeta (fotos + precio + comprar).
function resolveTarget(el){
  if(el && el.id === 'producto' && window.matchMedia('(max-width:880px)').matches){
    var card = el.querySelector('.pcard');
    if(card) return card;
  }
  return el;
}

function scrollToSection(el){
  el = resolveTarget(el);
  if(!el) return;
  var nav = navHeight();
  var libre = window.innerHeight - nav;
  var r = el.getBoundingClientRect();
  var top = r.top + window.pageYOffset;
  var offset = (r.height < libre) ? top - nav - (libre - r.height)/2 : top - nav - 12;
  window.scrollTo({top: Math.max(0, Math.round(offset)), behavior:'smooth'});
}

// Lleva a la tarjeta de producto (tiene cantidad, precio y comprar).
// En la página de producto no existe #producto, así que cae a #comprar.
function goBuy(){
  closeDrawer();
  scrollToSection(document.getElementById('producto') || document.getElementById('comprar'));
}

// Enlaces con ancla (#producto, #galeria, …): mismo centrado
document.addEventListener('click', function(e){
  var a = e.target.closest('a[href]');
  if(!a) return;
  var href = a.getAttribute('href') || '';
  var i = href.indexOf('#');
  if(i < 0) return;
  var id = href.slice(i+1);
  if(!id) return;
  var base = href.slice(0, i);
  if(base && base !== '/' && base !== location.pathname) return;   // enlace a otra página
  var el = document.getElementById(id);
  if(!el) return;
  e.preventDefault();
  closeDrawer();
  scrollToSection(el);
  if(history.replaceState) history.replaceState(null, '', '#' + id);
});

// ── CARRITO ──
// La fuente de verdad es el carrito de Shopify (/cart.js). En el preview local
// no hay Shopify, así que se usa un carrito de mentiras en memoria para poder
// probar la experiencia completa.
function isPreview(){
  return location.protocol === 'file:' || /^(localhost|127\.0\.0\.1)$/.test(location.hostname);
}

// subtotal = ya con descuentos (lo que de verdad paga); discounts = descuentos de todo el pedido
var CART = { items: [], subtotal: 0, discounts: [] };

function esc(s){
  return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){
    return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;' }[c];
  });
}
function cartCount(){
  return CART.items.reduce(function(n, i){ return n + i.quantity; }, 0);
}

// Traduce la respuesta de Shopify a lo que pinta el panel.
// Cada línea trae su precio original y el final (con descuentos de producto, p. ej. el pack).
function fromShopify(c){
  CART.items = (c.items || []).map(function(it, i){
    var vt = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
    var promos = (it.line_level_discount_allocations || []).map(function(d){
      return d.discount_application && d.discount_application.title;
    }).filter(Boolean);
    return { line: i + 1, id: it.variant_id, title: it.product_title, variante: vt,
             price: it.original_price / 100, quantity: it.quantity, image: it.image,
             original: it.original_line_price / 100, lineTotal: it.final_line_price / 100, promos: promos };
  });
  // Descuentos de todo el pedido (p. ej. un código del evento)
  CART.discounts = (c.cart_level_discount_applications || []).map(function(d){
    return { title: d.title, amount: (d.total_allocated_amount || 0) / 100 };
  });
  CART.subtotal = (c.total_price || 0) / 100;
  return CART;
}

function itemOf(handle){
  var id = String(CATALOG[handle].variant), hit = null;
  CART.items.forEach(function(i){ if(String(i.id) === id) hit = i; });
  return hit;
}

// Preview: imita el descuento automático del pack para poder ver cómo queda
function recalcPreview(){
  CART.items = CART.items.filter(function(i){ return i.quantity > 0; });
  CART.items.forEach(function(i, n){
    i.line = n + 1; i.original = i.price * i.quantity; i.lineTotal = i.original; i.promos = [];
  });
  var bolas = itemOf('soft-ice'), marker = itemOf('ball-marker');
  if(bolas && marker && bolas.quantity >= 2){
    marker.lineTotal -= packRegular() - PACK.price;
    marker.promos = [PACK.name];
  }
  CART.discounts = [];
  CART.subtotal = CART.items.reduce(function(t, i){ return t + i.lineTotal; }, 0);
}

function readCart(){
  if(isPreview()) return Promise.resolve(CART);
  return fetch('/cart.js', { headers: { 'Accept':'application/json' } })
    .then(function(r){ return r.json(); })
    .then(fromShopify)
    .catch(function(){ return CART; });
}

// item: { id, quantity, title, variante, price, image }
function addToCart(item){ return addItems([item]); }

// Varios productos en UNA llamada: o entran todos o ninguno (p. ej. el pack)
function addItems(list){
  if(isPreview()){
    list.forEach(function(item){
      var hit = null;
      CART.items.forEach(function(i){ if(String(i.id) === String(item.id)) hit = i; });
      if(hit) hit.quantity += item.quantity;
      else CART.items.push({ line: CART.items.length + 1, id: item.id, title: item.title,
                             variante: item.variante || '', price: item.price,
                             quantity: item.quantity, image: item.image });
    });
    recalcPreview();
    return Promise.resolve(CART);
  }
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
    body: JSON.stringify({ items: list.map(function(item){ return { id: Number(item.id), quantity: item.quantity }; }) })
  }).then(function(r){
    if(r.ok) return readCart();
    // 422 = Shopify lo rechaza (p. ej. sin inventario)
    return r.json().then(function(e){ throw new Error((e && e.description) || 'No pudimos agregarlo.'); });
  });
}

function setLine(line, quantity){
  quantity = Math.max(0, quantity);
  if(isPreview()){
    CART.items.forEach(function(i){ if(i.line === line) i.quantity = quantity; });
    recalcPreview(); paintCart(); render();
    return;
  }
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
    body: JSON.stringify({ line: line, quantity: quantity })
  }).then(function(r){ return r.json(); })
    .then(fromShopify)
    .then(function(){ paintCart(); render(); })
    .catch(function(){ alert('No pudimos actualizar tu carrito. Intenta de nuevo.'); });
}

function openCart(){
  var c = document.getElementById('cart'), o = document.getElementById('cartOverlay');
  if(!c) return;
  c.classList.add('open'); c.setAttribute('aria-hidden', 'false');
  if(o) o.classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeCart(){
  var c = document.getElementById('cart'), o = document.getElementById('cartOverlay');
  if(!c) return;
  c.classList.remove('open'); c.setAttribute('aria-hidden', 'true');
  if(o) o.classList.remove('open');
  document.body.style.overflow = '';
}

function paintCart(){
  var badge = document.querySelector('[data-cart-count]');
  if(badge){ var n = cartCount(); badge.textContent = n; badge.hidden = n === 0; }

  var body = document.getElementById('cartBody'), foot = document.getElementById('cartFoot');
  if(!body || !foot) return;

  if(!CART.items.length){
    body.innerHTML = '<div class="cart-empty"><span>❄</span><p>Tu carrito está vacío.</p></div>';
    foot.innerHTML = '<a class="btn btn-buy cart-cta" href="#producto" data-act="close-cart">Ver Golf Balls</a>';
    return;
  }

  body.innerHTML = CART.items.map(function(i){
    return '<article class="cart-line">' +
      '<div class="cart-thumb">' +
        (i.image ? '<img src="' + esc(i.image) + '" alt="">' : '<span class="cart-ph">❄</span>') +
      '</div>' +
      '<div class="cart-info">' +
        '<h4>' + esc(i.title) + '</h4>' +
        (i.variante ? '<p class="cart-var">' + esc(i.variante) + '</p>' : '') +
        '<div class="cart-qty">' +
          '<button type="button" data-act="line-dec" data-line="' + i.line + '" aria-label="Quitar uno">−</button>' +
          '<span>' + i.quantity + '</span>' +
          '<button type="button" data-act="line-inc" data-line="' + i.line + '" aria-label="Agregar uno">+</button>' +
          '<button type="button" class="cart-del" data-act="line-del" data-line="' + i.line + '">Quitar</button>' +
        '</div>' +
      '</div>' +
      '<div class="cart-price">' +
        (i.original > i.lineTotal ? '<s>' + fmt(i.original) + '</s>' : '') + fmt(i.lineTotal) +
        (i.promos && i.promos.length ? '<span class="cart-promo">' + esc(i.promos.join(' · ')) + '</span>' : '') +
      '</div>' +
    '</article>';
  }).join('') + upsellHTML();

  var falta = FREE_SHIP - CART.subtotal;
  var pct = Math.min(100, Math.round(CART.subtotal / FREE_SHIP * 100));
  foot.innerHTML =
    '<div class="cart-ship">' +
      '<div class="shipbar"><div class="shipfill" style="width:' + pct + '%"></div></div>' +
      '<p class="shipmsg">' + (falta <= 0 ? '¡Felicidades! Tienes envío gratis ❄'
                                          : 'Te faltan ' + fmt(falta) + ' para envío gratis') + '</p>' +
    '</div>' +
    CART.discounts.map(function(d){
      return '<div class="cart-disc"><span>' + esc(d.title) + '</span><span>−' + fmt(d.amount) + '</span></div>';
    }).join('') +
    '<div class="cart-total"><span>Subtotal</span><strong>' + fmt(CART.subtotal) + '</strong></div>' +
    '<button type="button" class="btn btn-buy cart-cta" data-act="checkout">Ir a pagar</button>' +
    '<p class="cart-note">Envío e impuestos se calculan al pagar.</p>';
}

// ── OFERTA EN EL CARRITO: "¿Agregas un Ball Marker?" ──
// Sale cuando llevas Soft Ice y todavía no llevas marker (con o sin COLD PACK).
// En la tienda solo si el marker está publicado y con inventario (snippets/cart-upsell-data).
// "No, gracias" la esconde hasta que cierre el navegador.
function upsellHTML(){
  var d = document.getElementById('upsellData');
  if(!d || (d.getAttribute('data-ready') !== 'true' && !isPreview())) return '';
  if(!itemOf('soft-ice') || itemOf('ball-marker')) return '';
  try{ if(sessionStorage.getItem('sz_upsell_no')) return ''; }catch(e){}
  return '<div class="cart-up">' +
    '<div class="cart-thumb"><img src="' + esc(d.getAttribute('data-img')) + '" alt=""></div>' +
    '<div class="cart-up-info">' +
      '<p class="cart-up-k">Completa tu juego</p>' +
      '<h4>Ball Marker</h4>' +
      '<p class="cart-up-d">Con pin magnético · ' + fmt(CATALOG['ball-marker'].price) + '</p>' +
    '</div>' +
    '<div class="cart-up-act">' +
      '<button type="button" class="cart-up-add" data-act="upsell-add">Agregar</button>' +
      '<button type="button" class="cart-up-no" data-act="upsell-no">No, gracias</button>' +
    '</div>' +
  '</div>';
}
function upsellAdd(btn){
  var m = CATALOG['ball-marker'], d = document.getElementById('upsellData');
  if(btn) btn.disabled = true;
  addToCart({ id: m.variant, quantity: 1, title: 'Ball Marker', price: m.price,
              image: d ? d.getAttribute('data-img') : null })
    .then(function(){ agregado(); }).catch(function(err){ if(btn) btn.disabled = false; agregado(err); });
}
function upsellNo(){
  try{ sessionStorage.setItem('sz_upsell_no', '1'); }catch(e){}
  paintCart();
}

// Evita doble clic mientras se agrega
function lockBuy(on){
  document.querySelectorAll('[data-act="buy"],[data-act="buy-item"]').forEach(function(b){ b.disabled = on; });
}

function agregado(err){
  lockBuy(false);
  if(err){ alert(err.message || 'No pudimos agregarlo. Intenta de nuevo.'); return; }
  paintCart(); render(); openCart();
}

// Producto principal (selector de cantidad)
function addMain(){
  if(!mainItem.variant) return;
  var img = document.querySelector('.pcard-slide img, .pdp-img');
  lockBuy(true);
  addToCart({
    id: mainItem.variant,
    quantity: qty,
    title: mainItem.handle === 'soft-ice' ? 'Soft Ice' : (document.querySelector('.pdp-info .title') || {}).textContent || 'Producto',
    variante: mainItem.handle === 'soft-ice' ? 'Docena' : '',
    price: mainItem.price,
    image: img ? img.getAttribute('src') : null
  }).then(function(){ agregado(); }).catch(agregado);
}

// Accesorio (botón de su tarjeta)
function buyItem(el){
  var id = el.getAttribute('data-variant');
  if(!id) return;
  lockBuy(true);
  addToCart({
    id: id,
    quantity: 1,
    title: el.getAttribute('data-name') || 'Accesorio',
    price: parseFloat(el.getAttribute('data-unit-price')) || 0,
    image: el.getAttribute('data-img') || null
  }).then(function(){ agregado(); }).catch(agregado);
}

function lineQty(el){
  var line = +el.getAttribute('data-line'), q = 0;
  CART.items.forEach(function(i){ if(i.line === line) q = i.quantity; });
  return q;
}

function goCheckout(){
  if(!CART.items.length) return;
  if(isPreview()){
    alert('⚠ Preview local. El pago solo funciona en Shopify.\n\n' +
      CART.items.map(function(i){ return i.quantity + ' × ' + i.title + ' — ' + fmt(i.lineTotal); }).join('\n') +
      '\n\nSubtotal: ' + fmt(CART.subtotal));
    return;
  }
  window.location.href = '/checkout';
}

// ── POP UP DEL PACK ──
// Sale al entrar (una vez cada 3 días si lo cierran; 30 si ya lo agregaron).
// En la tienda solo aparece cuando los dos productos están publicados y con
// inventario (data-ready, lo calcula snippets/pack-popup.liquid).
var packLastFocus = null;
function packStore(days){
  try{ localStorage.setItem('sz_pack_until', String(Date.now() + days*864e5)); }catch(e){}
}
function packSnoozed(){
  try{ return Date.now() < Number(localStorage.getItem('sz_pack_until') || 0); }catch(e){ return false; }
}
function packInCart(){
  var bolas = itemOf('soft-ice'), marker = itemOf('ball-marker');
  return !!(bolas && marker && bolas.quantity >= 2);
}
function openPack(){
  var pop = document.getElementById('packPop');
  if(!pop) return;
  packLastFocus = document.activeElement;
  pop.hidden = false;
  void pop.offsetWidth;            // fuerza el cálculo para que la animación de entrada corra
  pop.classList.add('open');
  document.body.style.overflow = 'hidden';
  var cta = pop.querySelector('[data-act="pack-add"]');
  if(cta) setTimeout(function(){ cta.focus({ preventScroll: true }); }, 50);
}
function closePack(days){
  var pop = document.getElementById('packPop');
  if(!pop || pop.hidden) return;
  pop.classList.remove('open');
  setTimeout(function(){ pop.hidden = true; }, 250);
  document.body.style.overflow = '';
  packStore(days || 3);
  if(packLastFocus && packLastFocus.focus) packLastFocus.focus({ preventScroll: true });
}
function addPack(){
  var cta = document.querySelector('[data-act="pack-add"]');
  if(cta) cta.disabled = true;
  var img = { 'soft-ice': (document.querySelector('.pcard-slide img') || {}).src || null,
              'ball-marker': (document.querySelector('.acc-slide img') || {}).src || null };
  addItems(PACK.items.map(function(it){
    var c = CATALOG[it[0]];
    return { id: c.variant, quantity: it[1], title: c.name, price: c.price, image: img[it[0]] };
  })).then(function(){
    if(cta) cta.disabled = false;
    closePack(30);
    paintCart(); render(); openCart();
  }).catch(function(err){
    if(cta) cta.disabled = false;
    alert((err && err.message) || 'No pudimos agregar el pack. Intenta de nuevo.');
  });
}
(function(){
  var pop = document.getElementById('packPop');
  if(!pop) return;
  // Precios desde PACK/CATALOG: un solo lugar para cambiarlos
  var reg = packRegular();
  pop.querySelectorAll('[data-pack-price]').forEach(function(e){ e.textContent = fmt(PACK.price); });
  pop.querySelectorAll('[data-pack-regular]').forEach(function(e){ e.textContent = fmt(reg); });
  pop.querySelectorAll('[data-pack-save]').forEach(function(e){ e.textContent = fmt(reg - PACK.price); });

  var listo = pop.getAttribute('data-ready') === 'true' || isPreview();
  var forzar = /[?&]pack=1\b/.test(location.search);           // para probarlo: ?pack=1
  if(!forzar && (!PACK.active || !listo || packSnoozed())) return;
  setTimeout(function(){
    readCart().then(function(){ if(forzar || !packInCart()) openPack(); });
  }, 900);
})();

// Al cargar y al volver con "atrás": leer el carrito real
window.addEventListener('pageshow', function(){
  lockBuy(false);
  readCart().then(function(){ paintCart(); render(); });
});
document.addEventListener('keydown', function(e){
  if(e.key === 'Escape'){ closeCart(); closePack(); }
});

// ── TICKER + STRIP marquees (width-aware, siempre llenan la barra) ──
(function(){
  var t = ['Envío gratis arriba de $999','Envíos a todo México'];
  var s = ['Soft Ice','2PC Urethane','Play it cool'];
  function pass(arr){ var h=''; arr.forEach(function(x){ h+='<span>'+x+'</span>'; }); return h; }
  function marquee(el, arr){
    if(!el) return;
    var container = el.parentElement;
    function build(passes){
      var half=''; for(var p=0;p<passes;p++){ half+=pass(arr); }
      el.innerHTML = half + half;           // dos mitades idénticas → -50% sin saltos
    }
    function passWidth(){
      el.innerHTML = pass(arr);             // una sola pasada para medir su ancho real
      var w=0, ch=el.children;
      for(var i=0;i<ch.length;i++){ w += ch[i].getBoundingClientRect().width; }
      return w || 1;
    }
    function fit(){
      var onePass = passWidth();            // ancho real del contenido (no del track estirado)
      var need = Math.max(2, Math.ceil((container.clientWidth*1.6)/onePass));
      build(need);
    }
    fit();
    var to; window.addEventListener('resize', function(){ clearTimeout(to); to=setTimeout(fit,150); });
    window.addEventListener('load', fit);                       // re-medir tras layout final
    if(document.fonts && document.fonts.ready){ document.fonts.ready.then(fit); } // y tras cargar la fuente
  }
  marquee(document.getElementById('tick'), t);
  marquee(document.getElementById('strip'), s);
})();

// ── DRAWER ──
function openDrawer(){
  document.getElementById('drawer').classList.add('open');
  document.getElementById('overlay').classList.add('open');
}
function closeDrawer(){
  document.getElementById('drawer').classList.remove('open');
  document.getElementById('overlay').classList.remove('open');
}

// ── PRODUCT CAROUSEL ──
(function(){
  var car = document.getElementById('pcardCarousel');
  var dotsWrap = document.getElementById('pcardDots');
  if(!car || !dotsWrap) return;
  var track = car.querySelector('.pcard-track');
  var slides = track.querySelectorAll('.pcard-slide');
  var dots = dotsWrap.querySelectorAll('.pcard-dot');
  if(!slides.length) return;

  function current(){ return Math.round(track.scrollLeft / track.clientWidth); }
  function goTo(i){
    i = Math.max(0, Math.min(slides.length-1, i));
    track.scrollTo({left: i*track.clientWidth, behavior:'smooth'});
  }
  track.addEventListener('scroll', function(){
    var idx = current();
    dots.forEach(function(d,k){ d.classList.toggle('active', k===idx); });
  });
  dots.forEach(function(d,k){ d.addEventListener('click', function(){ goTo(k); }); });

  car.querySelectorAll('[data-carousel-prev]').forEach(function(b){
    b.addEventListener('click', function(){ goTo(current()-1); });
  });
  car.querySelectorAll('[data-carousel-next]').forEach(function(b){
    b.addEventListener('click', function(){ goTo(current()+1); });
  });
})();

// ── MINI CARRUSEL (accesorios del home y fotos/videos de la página de producto) ──
document.querySelectorAll('[data-mini-carousel]').forEach(function(car){
  var track = car.querySelector('[data-mc-track]');
  var slides = track.children;
  var dots = car.querySelectorAll('.pcard-dot');
  function current(){ return Math.round(track.scrollLeft / track.clientWidth); }
  function goTo(i){
    i = (i + slides.length) % slides.length;          // da la vuelta en los extremos
    track.scrollTo({left: i*track.clientWidth, behavior:'smooth'});
  }
  track.addEventListener('scroll', function(){
    var idx = current();
    dots.forEach(function(d,k){ d.classList.toggle('active', k===idx); });
  });
  dots.forEach(function(d,k){ d.addEventListener('click', function(){ goTo(k); }); });
  var prev = car.querySelector('[data-mc-prev]'), next = car.querySelector('[data-mc-next]');
  if(prev) prev.addEventListener('click', function(){ goTo(current()-1); });
  if(next) next.addEventListener('click', function(){ goTo(current()+1); });
});

// ── CONSTRUCTION CAROUSEL DOTS (mobile) ──
(function(){
  var grid = document.getElementById('consGrid');
  var dotsWrap = document.getElementById('consDots');
  if(!grid || !dotsWrap) return;
  var dots = dotsWrap.querySelectorAll('.cons-dot');
  var cards = grid.querySelectorAll('.layer');
  if(!dots.length || !cards.length) return;
  function step(){ return cards.length>1 ? (cards[1].offsetLeft - cards[0].offsetLeft) : cards[0].offsetWidth; }
  grid.addEventListener('scroll', function(){
    var idx = Math.round(grid.scrollLeft / step());
    idx = Math.max(0, Math.min(cards.length-1, idx));
    dots.forEach(function(d,k){ d.classList.toggle('active', k===idx); });
  });
  dots.forEach(function(d,k){
    d.addEventListener('click', function(){
      grid.scrollTo({left: k*step(), behavior:'smooth'});
    });
  });
})();

// ── LIGHTBOX (zoom para todas las fotos) ──
(function(){
  var lb = document.getElementById('lightbox');
  var img = document.getElementById('lbImg');
  var stage = document.getElementById('lbStage');
  if(!lb || !img) return;
  var scale=1, tx=0, ty=0, minS=1, maxS=4;

  function apply(){ img.style.transform='translate('+tx+'px,'+ty+'px) scale('+scale+')'; img.classList.toggle('zoomed', scale>1.01); }
  function reset(){ scale=1; tx=0; ty=0; apply(); }
  // galería activa: permite cambiar de foto sin cerrar el lightbox
  var group = [], idx = 0;
  var counter = document.getElementById('lbCount');

  function paint(){
    var z = group[idx]; if(!z) return;
    img.src = z.getAttribute('data-full') || z.currentSrc || z.src;
    img.alt = z.alt || '';
    reset();
    if(counter) counter.textContent = group.length > 1 ? (idx+1)+' / '+group.length : '';
    lb.classList.toggle('single', group.length < 2);
  }
  function show(i){ if(!group.length) return; idx = (i + group.length) % group.length; paint(); }
  function open(z){
    // agrupa por su contenedor (carrusel de producto o galería)
    var box = z.closest('.pcard-track, .gal-grid, .pdp-media, .acc-track');
    group = box ? Array.prototype.slice.call(box.querySelectorAll('img[data-zoom]'))
                : [z];
    idx = Math.max(0, group.indexOf(z));
    paint();
    lb.classList.add('open'); lb.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden';
  }
  function close(){ lb.classList.remove('open'); lb.setAttribute('aria-hidden','true'); document.body.style.overflow=''; }

  document.addEventListener('click', function(e){
    var z = e.target.closest('img[data-zoom]');
    if(z){ open(z); return; }
    if(e.target.closest('[data-act="lb-close"]')){ close(); return; }
    if(e.target.closest('[data-act="lb-prev"]')){ show(idx-1); return; }
    if(e.target.closest('[data-act="lb-next"]')){ show(idx+1); return; }
  });
  lb.addEventListener('click', function(e){ if(e.target===lb || e.target===stage){ close(); } });
  document.addEventListener('keydown', function(e){
    if(!lb.classList.contains('open')) return;
    if(e.key==='Escape') close();
    else if(e.key==='ArrowLeft') show(idx-1);
    else if(e.key==='ArrowRight') show(idx+1);
  });

  // deslizar con el dedo para cambiar de foto (solo si no hay zoom)
  var sx=0, sy=0, swiping=false;
  lb.addEventListener('touchstart', function(e){
    if(e.touches.length===1 && scale<=1.01){ swiping=true; sx=e.touches[0].clientX; sy=e.touches[0].clientY; }
    else swiping=false;
  }, {passive:true});
  lb.addEventListener('touchend', function(e){
    if(!swiping) return; swiping=false;
    var t=e.changedTouches[0], dx=t.clientX-sx, dy=t.clientY-sy;
    if(Math.abs(dx)>50 && Math.abs(dx)>Math.abs(dy)) show(idx + (dx<0?1:-1));
  }, {passive:true});

  // rueda (desktop)
  lb.addEventListener('wheel', function(e){
    if(!lb.classList.contains('open')) return;
    e.preventDefault();
    scale = Math.max(minS, Math.min(maxS, scale + (e.deltaY<0?0.25:-0.25)));
    if(scale<=1){ tx=0; ty=0; }
    apply();
  }, {passive:false});

  // doble clic / doble toque
  img.addEventListener('dblclick', function(e){ e.preventDefault(); if(scale>1) reset(); else { scale=2.4; apply(); } });

  // arrastre con mouse
  var drag=false, sx=0, sy=0, stx=0, sty=0;
  img.addEventListener('mousedown', function(e){ if(scale<=1) return; drag=true; sx=e.clientX; sy=e.clientY; stx=tx; sty=ty; e.preventDefault(); });
  window.addEventListener('mousemove', function(e){ if(!drag) return; tx=stx+(e.clientX-sx); ty=sty+(e.clientY-sy); apply(); });
  window.addEventListener('mouseup', function(){ drag=false; });

  // touch: pellizco para zoom + un dedo para mover
  var pts={}, startDist=0, startScale=1, ptx=0, pty=0, psx=0, psy=0, lastTap=0;
  function dist(a,b){ var dx=a.x-b.x, dy=a.y-b.y; return Math.sqrt(dx*dx+dy*dy); }
  img.addEventListener('touchstart', function(e){
    pts={};
    for(var i=0;i<e.touches.length;i++){ var t=e.touches[i]; pts[t.identifier]={x:t.clientX,y:t.clientY}; }
    var ids=Object.keys(pts);
    if(ids.length===2){ startDist=dist(pts[ids[0]],pts[ids[1]]); startScale=scale; }
    else if(ids.length===1){
      psx=e.touches[0].clientX; psy=e.touches[0].clientY; ptx=tx; pty=ty;
      var now=Date.now(); if(now-lastTap<300){ if(scale>1) reset(); else { scale=2.4; apply(); } } lastTap=now;
    }
  }, {passive:false});
  img.addEventListener('touchmove', function(e){
    if(e.touches.length===2){
      e.preventDefault();
      var a={x:e.touches[0].clientX,y:e.touches[0].clientY}, b={x:e.touches[1].clientX,y:e.touches[1].clientY};
      scale=Math.max(minS, Math.min(maxS, startScale*(dist(a,b)/(startDist||1)))); apply();
    } else if(e.touches.length===1 && scale>1){
      e.preventDefault();
      tx=ptx+(e.touches[0].clientX-psx); ty=pty+(e.touches[0].clientY-psy); apply();
    }
  }, {passive:false});
  img.addEventListener('touchend', function(){ if(scale<=1) reset(); });
})();

// ── RESEÑAS: carrusel (auto en desktop vía CSS; auto + swipe en mobile vía JS) ──
(function(){
  var marquee = document.querySelector('.rev-marquee');
  var track = document.querySelector('[data-rev-track]');
  if(!marquee || !track) return;
  track.innerHTML += track.innerHTML; // duplica las tarjetas para un loop continuo

  var mq = window.matchMedia('(max-width:880px)');
  var reduce = window.matchMedia('(prefers-reduced-motion:reduce)');
  var raf = null, paused = false, resumeTimer = null;

  // Loop infinito: la 2ª mitad es copia de la 1ª, así que al cruzar la mitad
  // retrocedemos medio ancho sin salto visible. Aplica a auto Y a scroll manual.
  function wrap(){
    var half = marquee.scrollWidth / 2;
    if(half > 0 && marquee.scrollLeft >= half){ marquee.scrollLeft -= half; }
  }
  function loop(){
    if(!paused){ marquee.scrollLeft += 0.3; }    // velocidad lenta en mobile
    wrap();
    raf = requestAnimationFrame(loop);
  }
  function pause(){                              // el cliente toca → pausa y puede navegar
    paused = true;
    clearTimeout(resumeTimer);
    resumeTimer = setTimeout(function(){ paused = false; }, 2500);
  }
  function enableMobile(){
    if(raf || marquee.dataset.revMobile === '1') return;
    marquee.dataset.revMobile = '1';
    marquee.addEventListener('touchstart', pause, {passive:true});
    marquee.addEventListener('pointerdown', pause, {passive:true});
    marquee.addEventListener('wheel', pause, {passive:true});
    marquee.addEventListener('scroll', wrap, {passive:true}); // loop en scroll manual
    if(!reduce.matches) raf = requestAnimationFrame(loop);     // reduced-motion: solo swipe manual
  }
  function disableMobile(){
    if(raf){ cancelAnimationFrame(raf); raf = null; }
    paused = false; clearTimeout(resumeTimer);
    marquee.dataset.revMobile = '0';
    marquee.removeEventListener('touchstart', pause);
    marquee.removeEventListener('pointerdown', pause);
    marquee.removeEventListener('wheel', pause);
    marquee.removeEventListener('scroll', wrap);
    marquee.scrollLeft = 0;
  }
  function apply(){ if(mq.matches) enableMobile(); else disableMobile(); }
  apply();
  if(mq.addEventListener) mq.addEventListener('change', apply);
  else if(mq.addListener) mq.addListener(apply);
})();

// ── REVEAL ON SCROLL ──
(function(){
  var els = document.querySelectorAll('.reveal');
  if(!els.length) return;
  var io = new IntersectionObserver(function(en){
    en.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }});
  }, {threshold:.12});
  els.forEach(function(e){ io.observe(e); });
})();

// ── EVENT DELEGATION (robust on Shopify) ──
document.addEventListener('click', function(e){
  var el = e.target.closest('[data-act]');
  if(!el) return;
  if(el.disabled) return;
  var act = el.getAttribute('data-act');
  if(act === 'dec') step(-1);
  else if(act === 'inc') step(1);
  else if(act === 'buy') addMain();
  else if(act === 'buy-item') buyItem(el);
  else if(act === 'open-cart') openCart();
  else if(act === 'close-cart') closeCart();
  else if(act === 'checkout') goCheckout();
  else if(act === 'line-inc') setLine(+el.getAttribute('data-line'), lineQty(el) + 1);
  else if(act === 'line-dec') setLine(+el.getAttribute('data-line'), lineQty(el) - 1);
  else if(act === 'line-del') setLine(+el.getAttribute('data-line'), 0);
  else if(act === 'gobuy') goBuy();
  else if(act === 'upsell-add') upsellAdd(el);
  else if(act === 'upsell-no') upsellNo();
  else if(act === 'pack-add') addPack();
  else if(act === 'pack-close') closePack();
  else if(act === 'open-drawer') openDrawer();
  else if(act === 'close-drawer') closeDrawer();
});

// Videos de producto (accesorios): quietos si el usuario pidió menos movimiento,
// y en pausa cuando no están en pantalla para no gastar batería.
(function(){
  var vids = document.querySelectorAll('.acc-video, .pdp-video');
  if(!vids.length) return;
  if(window.matchMedia('(prefers-reduced-motion:reduce)').matches){
    vids.forEach(function(v){ v.removeAttribute('autoplay'); v.pause(); });
    return;
  }
  if(!('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){ var p = e.target.play(); if(p && p.catch) p.catch(function(){}); }
      else e.target.pause();
    });
  }, { threshold: 0.15 });
  vids.forEach(function(v){ io.observe(v); });
})();

// Init pricing
document.addEventListener('DOMContentLoaded', render);
render();
